module.exports = __webpack_public_path__ + "static/img/fefco200_2.77fbe08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco200_2.png
// module id = FAMj
// module chunks = 0